export interface Props {
    className: string;
    renderWithSpan?: boolean;
}

export default function Icon({ className, renderWithSpan = false }: Props) {
    return renderWithSpan ? <span className={`icon ${className}`} /> : <div className={`icon ${className}`} />;
}
